// 保单类型
export const policyTypeList = [{
  value: 1,
  label: '新车投保'
}, {
  value: 0,
  label: '旧车换胎'
}]